import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendMessageMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  content: Types.Scalars['String']['input'];
  form: Types.Scalars['ID']['input'];
  chat: Types.Scalars['ID']['input'];
  recordId: Types.Scalars['ID']['input'];
}>;


export type SendMessageMutation = { __typename: 'PharosMutations', llmChatMessage_Update: { __typename: 'llm_chat_messagePayload', object: { __typename: 'LlmChatMessageType', id: string, chat: { __typename: 'LlmChatType', id: string } } | null, errors: Array<{ __typename: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type SendMessagePubMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  content: Types.Scalars['String']['input'];
  form: Types.Scalars['ID']['input'];
  chat: Types.Scalars['ID']['input'];
  recordId: Types.Scalars['ID']['input'];
}>;


export type SendMessagePubMutation = { __typename: 'PharosMutations', llmChatMessagePub_Update: { __typename: 'llm_chat_pub_messagePayload', object: { __typename: 'LlmChatMessagePubType', id: string, chat: { __typename: 'LlmChatPubType', id: string } } | null, errors: Array<{ __typename: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type PollLlmChatQueryVariables = Types.Exact<{
  chatId: Types.Scalars['ID']['input'];
}>;


export type PollLlmChatQuery = { __typename: 'PharosQuery', llmChat: { __typename: 'LlmChatType', id: string, created: string, processingCutoffSeconds: number | null, messages: Array<{ __typename: 'LlmChatMessageType', id: string, content: string, created: string, sender: Types.LlmChatMessageSenderType, responseReceivedAt: string | null }> } | null };

export type PollLlmChatPubQueryVariables = Types.Exact<{
  chatId: Types.Scalars['ID']['input'];
}>;


export type PollLlmChatPubQuery = { __typename: 'PharosQuery', llmChatPub: { __typename: 'LlmChatPubType', id: string, created: string, processingCutoffSeconds: number | null, messages: Array<{ __typename: 'LlmChatMessagePubType', id: string, content: string, created: string, sender: Types.LlmChatMessageSenderType, responseReceivedAt: string | null }> } | null };

export type StreamingMessageFragment = { __typename: 'LlmChatMessageType', content: string };

export type StreamingMessagePubFragment = { __typename: 'LlmChatMessagePubType', content: string };

export const StreamingMessageFragmentDoc = gql`
    fragment StreamingMessage on LlmChatMessageType {
  content
}
    `;
export const StreamingMessagePubFragmentDoc = gql`
    fragment StreamingMessagePub on LlmChatMessagePubType {
  content
}
    `;
export const SendMessageDocument = gql`
    mutation sendMessage($id: ID!, $content: String!, $form: ID!, $chat: ID!, $recordId: ID!) {
  llmChatMessage_Update(
    input: {id: $id, content: $content, chat: $chat, record: $recordId, form: $form}
  ) {
    object {
      id
      chat {
        id
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *      form: // value for 'form'
 *      chat: // value for 'chat'
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const SendMessagePubDocument = gql`
    mutation sendMessagePub($id: ID!, $content: String!, $form: ID!, $chat: ID!, $recordId: ID!) {
  llmChatMessagePub_Update(
    input: {id: $id, content: $content, chat: $chat, record: $recordId, form: $form}
  ) {
    object {
      id
      chat {
        id
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type SendMessagePubMutationFn = Apollo.MutationFunction<SendMessagePubMutation, SendMessagePubMutationVariables>;

/**
 * __useSendMessagePubMutation__
 *
 * To run a mutation, you first call `useSendMessagePubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessagePubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessagePubMutation, { data, loading, error }] = useSendMessagePubMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *      form: // value for 'form'
 *      chat: // value for 'chat'
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useSendMessagePubMutation(baseOptions?: Apollo.MutationHookOptions<SendMessagePubMutation, SendMessagePubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessagePubMutation, SendMessagePubMutationVariables>(SendMessagePubDocument, options);
      }
export type SendMessagePubMutationHookResult = ReturnType<typeof useSendMessagePubMutation>;
export type SendMessagePubMutationResult = Apollo.MutationResult<SendMessagePubMutation>;
export type SendMessagePubMutationOptions = Apollo.BaseMutationOptions<SendMessagePubMutation, SendMessagePubMutationVariables>;
export const PollLlmChatDocument = gql`
    query PollLlmChat($chatId: ID!) {
  llmChat(id: $chatId) {
    id
    created
    processingCutoffSeconds
    messages(orderBy: [{field: created, direction: ASC}]) {
      id
      content
      created
      sender
      responseReceivedAt
    }
  }
}
    `;

/**
 * __usePollLlmChatQuery__
 *
 * To run a query within a React component, call `usePollLlmChatQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollLlmChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollLlmChatQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function usePollLlmChatQuery(baseOptions: Apollo.QueryHookOptions<PollLlmChatQuery, PollLlmChatQueryVariables> & ({ variables: PollLlmChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollLlmChatQuery, PollLlmChatQueryVariables>(PollLlmChatDocument, options);
      }
export function usePollLlmChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollLlmChatQuery, PollLlmChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollLlmChatQuery, PollLlmChatQueryVariables>(PollLlmChatDocument, options);
        }
export function usePollLlmChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PollLlmChatQuery, PollLlmChatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PollLlmChatQuery, PollLlmChatQueryVariables>(PollLlmChatDocument, options);
        }
export type PollLlmChatQueryHookResult = ReturnType<typeof usePollLlmChatQuery>;
export type PollLlmChatLazyQueryHookResult = ReturnType<typeof usePollLlmChatLazyQuery>;
export type PollLlmChatSuspenseQueryHookResult = ReturnType<typeof usePollLlmChatSuspenseQuery>;
export type PollLlmChatQueryResult = Apollo.QueryResult<PollLlmChatQuery, PollLlmChatQueryVariables>;
export const PollLlmChatPubDocument = gql`
    query PollLlmChatPub($chatId: ID!) {
  llmChatPub(id: $chatId) {
    id
    created
    processingCutoffSeconds
    messages(orderBy: [{field: created, direction: ASC}]) {
      id
      content
      created
      sender
      responseReceivedAt
    }
  }
}
    `;

/**
 * __usePollLlmChatPubQuery__
 *
 * To run a query within a React component, call `usePollLlmChatPubQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollLlmChatPubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollLlmChatPubQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function usePollLlmChatPubQuery(baseOptions: Apollo.QueryHookOptions<PollLlmChatPubQuery, PollLlmChatPubQueryVariables> & ({ variables: PollLlmChatPubQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollLlmChatPubQuery, PollLlmChatPubQueryVariables>(PollLlmChatPubDocument, options);
      }
export function usePollLlmChatPubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollLlmChatPubQuery, PollLlmChatPubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollLlmChatPubQuery, PollLlmChatPubQueryVariables>(PollLlmChatPubDocument, options);
        }
export function usePollLlmChatPubSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PollLlmChatPubQuery, PollLlmChatPubQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PollLlmChatPubQuery, PollLlmChatPubQueryVariables>(PollLlmChatPubDocument, options);
        }
export type PollLlmChatPubQueryHookResult = ReturnType<typeof usePollLlmChatPubQuery>;
export type PollLlmChatPubLazyQueryHookResult = ReturnType<typeof usePollLlmChatPubLazyQuery>;
export type PollLlmChatPubSuspenseQueryHookResult = ReturnType<typeof usePollLlmChatPubSuspenseQuery>;
export type PollLlmChatPubQueryResult = Apollo.QueryResult<PollLlmChatPubQuery, PollLlmChatPubQueryVariables>;